import { api } from "@api/api";
import { PromocodeBatch } from "@modules/promocodeBatches/types";
import { PromocodeBatchFormValues } from "@modules/promocodeBatches/validations";

export async function editPromocodeBatchService(id: string, data: PromocodeBatchFormValues): Promise<PromocodeBatch> {
  const { data: promocode } = await api.patch<PromocodeBatch>(`v1/promocode_batch_admin/${id}/`, data);

  return promocode;
}
